<template>
  <div>
    <section class="section">
      <div class="container">
        <!-- 管理者用のメニュー -->
        <div v-if="super_user">
          <h1 class="is-size-1">情報共有システム管理者メニュー</h1>
          <div>
            <router-link to="/notice/new">
              <button class="button is-danger is-size-3 is-rounded">新規お知らせ登録</button>
            </router-link>
          </div>
          <div>
            <router-link to="/logs/list">
              <button class="button is-danger is-size-3 is-rounded">過去ログ一覧</button>
            </router-link>
          </div>
          <div>
            <router-link to="/settings/menu">
            <button class="button is-danger is-size-3 is-rounded">設定</button>
            </router-link>
          </div>
        </div>
        <!-- 管理者用のメニュー ここまで -->
        <!-- 一般用のメニュー -->
        <div v-else>
          <h1 class="is-size-1">情報共有システム</h1>
          <div v-if="isErrors || isErrorsNews">
            <p class="hero">
              <span class="has-text-danger">{{ isErrors }}</span>
              <span class="has-text-danger">{{ isErrorsNews }}</span>
            </p>
          </div>
          <div class="main" v-for="(group, i) in groups" v-bind:key="group.id">
            <router-link :to="{ name: 'driver', params: { group: group.id } }">
              <button class="button is-size-3 is-rounded" :class="classes[i]">
                <template v-if="unreadNews(group.id).length > 0">
                  <p class="button is-size-7 notice is-rounded">{{ unreadNews(group.id).length }}</p>
                </template>
                {{ group.name }}
              </button>
            </router-link>
          </div>
        </div>
        <!-- 一般用のメニュー ここまで -->
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  data: function(){
    return {
      intervalId: null,
      requestTime: 15, //sec
      classes:[
        "is-primary",
        "is-danger",
        "is-link",
        "is-info",
        "is-success",
        "is-warning",
      ]
    }
  },
  computed: {
    ...mapGetters({
      super_user: 'auth/super_user',
      groups: 'news/groups',
      unreadNews: 'users/unreadNews'
    }),
    ...mapState({
      isErrorsNews: state => state.users.errorMessages,
      isErrors: state => state.news.errorMessages,
    })
  },
  mounted(){
    this.$store.dispatch('news/newsGroupAndCategory')
    if(!this.super_user){
      this.getUserNewsList()
      this.intervalId = setInterval(this.getUserNewsList, this.requestTime * 1000)
    }
  },
  beforeDestroy () {
    clearInterval(this.intervalId)
  },
  methods: {
    getUserNewsList(){
      this.$store.dispatch('users/getUserNewsList')
    }
  },
}
</script>

<style scoped>
  .container {
    text-align: center;
  }
  button {
    min-width: calc(50% - 100px);
    margin: 12px 12px;
  }
  .hero {
    text-align: right;
    margin-right: 20px;
    margin-top: 10px;
  }
  .notice{
    position: absolute;
    right: 30px;
    top: 5px
  }
</style>